import * as React from 'react';

import { Right } from '../../icons';
import { ConstantFunctions } from '../../utils';
import { Text } from '../texts';
import Waves from '../waves';
import { Styled } from './styled';

interface Element {
  title: string;
  content: string;
}

interface Props {
  index: number;
  openBlocks: number[];
  setOpenBlocks: (openBlocks: number[]) => void;
  Icon: React.FC;
  element: Element;
}

export const AccordionElement: React.FC<Props> = ({
  index,
  openBlocks,
  setOpenBlocks,
  Icon,
  element,
}) => {
  const isOpen = openBlocks.includes(index);
  const handleOnClick = React.useCallback(
    (e) => {
      ConstantFunctions.stopEvent(e);
      isOpen
        ? setOpenBlocks(openBlocks.filter((el) => el !== index))
        : setOpenBlocks([...openBlocks, index]);
    },
    [isOpen, openBlocks],
  );

  return (
    <Styled.Block key={index}>
      <Styled.BlockHeader onClick={handleOnClick}>
        <Styled.ArrowContainer isOpen={isOpen}>
          {Icon ? <Icon /> : <Right />}
        </Styled.ArrowContainer>
        <Text>{element.title}</Text>
        <Waves />
      </Styled.BlockHeader>
      <Styled.BlockDescription isOpen={isOpen}>
        <Styled.DescriptionTextContainer isOpen={isOpen}>
          {element.content}
        </Styled.DescriptionTextContainer>
      </Styled.BlockDescription>
    </Styled.Block>
  );
};
